import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="obj-width">
        <div className="top">
          <div>
            <img src="/images/sourced/logo.png" alt="Alacritas Logo" />
            <p>Find your desired job with us</p>
          </div>
          <div>
            <Link to="/">
              <i className="bx bxs-home"></i>Home
            </Link>
            <Link to="/jobs">
              <i className="bx bxs-briefcase"></i>Jobs
            </Link>
            <Link to="/admin">
              <i className="bx bxs-lock-alt"></i>Admin
            </Link>
          </div>
          <div>
            <a href="/" onClick={(e) => e.preventDefault()}>
              <i className="bx bxl-facebook-square"></i>
            </a>
            <a href="/" onClick={(e) => e.preventDefault()}>
              <i className="bx bxl-twitter-square"></i>
            </a>
            <a href="/" onClick={(e) => e.preventDefault()}>
              <i className="bx bxl-linkedin-square"></i>
            </a>
          </div>
        </div>
        <h3>Alacritas</h3>
        <p>University of the Cordilleras, Governor Pack<br />Baguio City, Benguet, Philippines</p>
        <p>Email: info@alacritas.com</p>
      </div>
    </footer>
  );
};

export default Footer;
